<template>
    <Modal>
        <ModalCard
            :active-validate="false"
            :headerTitle="$t('preventif.suivi.modal.header')"
            :is-pop-up-table="true"
            :noPaddingTop="false"
            :withoutBotNav="true"
            class="modal-choix-site"
            @cancel="cancel"
        >
            <div v-if="!isMultiSite" class="flex">
                <div class="radio-container" @click="toogleAllSite(false)">
                    <RadioBox :selected="!isAllSites" />
                    <span class="span-container">{{ $t('preventif.suivi.modal.choix.un') }}</span>
                </div>
                <div class="radio-container" @click="toogleAllSite(true)">
                    <RadioBox :selected="isAllSites" />
                    <span class="span-container">{{ $t('preventif.suivi.modal.choix.tous') }}</span>
                </div>
                <ReglePastille v-if="regleCle" :cle="regleCle" />
            </div>

            <SelectSite
                :is-multi-site="isMultiSite"
                :inclure-termines="inclureTermines"
                :selected-sites="sites"
                :selectedSite="site"
                :sites-disabled="isAllSites"
                :sites-autorises="sitesAutorises"
                :title="$t('preventif.suivi.modal.recherche.titre')"
                class="select-site-container"
                @add="addSite"
                @addAll="addAllSite"
                @pick="pick"
                @filter-change="pick(undefined)"
            />

            <div class="button-modal-container">
                <ButtonBlue
                    :disabled="isMultiSite ? sites?.length === 0 : !isAllSites && !site"
                    :onClick="validerSite"
                    :text="$t('app.bottom.navigation.button.confirm')"
                    class="button-confirm btn"
                    name="confirm"
                />
            </div>
        </ModalCard>
    </Modal>
</template>

<script lang="ts">
import Modal from '@/components/ui-components/Modal.vue';
import ModalCard from '@/components/ui-components/ModalCard.vue';
import SelectSite from '@/modules/SiteList/components/SelectSite.vue';
import RadioBox from '@/components/ui-components/RadioBox.vue';
import ButtonBlue from '@/components/ui-components/ButtonBlue.vue';
import { defineComponent, PropType } from 'vue';
import { Site } from '@/models/Site';
import { store } from '@/plugins/store';
import { SITE_LIST } from '@/modules/SiteList/store/mutation-types';
import ReglePastille from '@/components/regles/ReglePastille.vue';

export default defineComponent({
    name: 'ModalChoixSite',
    data(): {
        isAllSites: boolean;
        site?: Site;
        sites?: Site[];
    } {
        return {
            isAllSites: false,
            site: undefined,
            sites: [],
        };
    },
    components: { Modal, ModalCard, SelectSite, RadioBox, ButtonBlue, ReglePastille },
    props: {
        selectedSite: { type: Object as PropType<Site>, required: true },
        selectedSites: { type: Array as PropType<Site[]>, required: true },
        isMultiSite: { type: Boolean, required: true },
        inclureTermines: { type: Boolean, required: false, default: false },
        regleCle: { type: String, required: false },
        sitesAutorises: { type: Array as PropType<Site[]>, required: false, default: () => [] },
    },
    beforeMount() {
        this.site = this.selectedSite;
        this.sites = this.selectedSites;
        store.commit(`siteList/${SITE_LIST.RESET_FILTER}`);
    },
    methods: {
        cancel(): void {
            this.$emit('cancel');
        },
        validerSite(): void {
            if (this.isMultiSite) {
                this.$emit('valider', this.sites);
            } else {
                let site: Site | undefined;
                if (this.isAllSites) {
                    site = undefined;
                } else {
                    site = this.site;
                }
                this.$emit('valider', site);
            }
        },
        pick(site: Site): void {
            if (site) {
                this.site = site;
            }
        },
        addSite(sites: Site[]): void {
            if (sites) {
                this.sites = sites;
            }
        },
        addAllSite(sites: Site[]): void {
            this.sites = [];
            sites.forEach(s => this.sites?.push(s));
        },
        toogleAllSite(isAllSites: boolean): void {
            this.isAllSites = isAllSites;
            this.sites = [];
            this.site = undefined;
        },
    },
});
</script>

<style scoped>
:deep(.card-content-container) {
    overflow: hidden;
}
.button-confirm {
    right: 16px;
}
.btn {
    width: 90px;
    border-radius: 5px;
    cursor: pointer;
    height: 40px;
    margin: 5px;
}
.button-modal-container {
    text-align: right;
}
.radio-container {
    cursor: pointer;
    padding: 8px 24px 8px 24px;
    width: 50%;
}
@media (max-height: 925px) {
    .radio-container {
        padding: 0 24px 0 24px;
    }
}
@media (max-height: 775px) {
    :deep(.card-content-container) {
        padding: 0;
    }
    .select-site-container {
        height: 52vh;
    }
}
@media (max-height: 675px) {
    .modal-choix-site {
        max-height: 80%;
    }
    :deep(.card-content-container) {
        max-height: 65vh;
    }
    .modal-choix-site {
        width: 70vw;
    }
}
@media (min-height: 676px) {
    .modal-choix-site {
        width: 50vw;
    }
}
@media (min-height: 776px) {
    .select-site-container {
        height: 39vh;
    }
}
.flex {
    display: flex;
}
.span-container {
    vertical-align: super;
}
:deep(.card-content-container) {
    max-height: 70vh;
}
:deep(.select-all-container) {
    display: flex;
}
:deep(.margin--10px) {
    margin-top: -10px;
}
:deep(.recherche-container) {
    display: flex;
}
:deep(.first-container) {
    width: 50%;
}
:deep(.search-bar) {
    width: 100%;
    margin-top: -5px;
}
:deep(.title) {
    width: 50%;
}
</style>
